import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { parseContentMetadata } from 'site-modules/shared/utils/parse-content-metadata';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { Link } from 'site-modules/shared/components/link/link';

export function RecommendedCategories({ title: sectionTitle, content, className = '' }) {
  return (
    <div className={classnames('recommended-categories', className)}>
      <h2 id="recommended-categories" className="heading-3 mb-1_5">
        {sectionTitle}
      </h2>
      <Row
        tag="ul"
        aria-labelledby="recommended-categories"
        className="list-unstyled bg-cool-gray-100 rounded-12 p-1_25"
        style={{ rowGap: '20px' }}
      >
        {parseContentMetadata(content, ['link-url', 'title'], 12).map(({ title, linkUrl }) => (
          <Col tag="li" key={title} xs={12} md={4}>
            <Link to={linkUrl} className="text-blue-30">
              {title}
            </Link>
          </Col>
        ))}
      </Row>
    </div>
  );
}

RecommendedCategories.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.shape({}).isRequired,
  className: PropTypes.string,
};
